import React, { FC, ReactNode } from 'react'
import { Container } from 'react-bootstrap'

interface AppPageComponentProps {
  children: ReactNode
}

const AppAppPageComponent: FC<AppPageComponentProps> = ({ children }) => {
  return <Container className="mw-100 m-0 p-0">{children}</Container>
}
export default AppAppPageComponent
